import { render, staticRenderFns } from "./BottomNavigationNew.vue?vue&type=template&id=3ea0a4ad&scoped=true"
import script from "./BottomNavigationNew.vue?vue&type=script&lang=js"
export * from "./BottomNavigationNew.vue?vue&type=script&lang=js"
import style0 from "./BottomNavigationNew.vue?vue&type=style&index=0&id=3ea0a4ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea0a4ad",
  null
  
)

export default component.exports